<template>
  <div>
    <RadioGroup
      itemValue="value"
      :items="options"
      :value="value"
      @input="$emit('input', $event)"
      :rules="rules"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    label: String,
    rules: {
      type: Array,
      default: function () {
        return [];
      },
    },
    links: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      options: [
        { title: "Yes", value: true },
        { title: "No", value: false },
      ],
    };
  },
};
</script>

<style scoped lang="scss"></style>
